var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-uploader',{attrs:{"after-read":_vm.afterRead,"multiple":""}},[_c('svg-icon',{attrs:{"icon-class":'img',"className":'baby'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }